<template>
  <v-row>
    <v-col cols="12">
      <!-- Sayfa başlığı: diğer ekranlarla aynı `ec-header` bloğu -->
      <div class="ec-header">
        <div class="ec-header__left">
          <div class="ec-header__icon">
            <v-icon size="22">mdi-cog-outline</v-icon>
          </div>
          <div>
            <h1 class="ec-header__title">Settings</h1>
            <p class="ec-header__subtitle">Platform-wide configuration and keys</p>
          </div>
        </div>
      </div>
    </v-col>
    <v-col md="12" lg="3">
      <v-navigation-drawer width="100%" permanent>
        <v-list nav class="pl-0">
          <v-list-item-group v-model="item" color="primary">
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              @click="$router.push('/general/' + item.path)"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="lato-bold font-16">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-col>
    <v-col md="12" lg="9">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>
<script>
export default {
  created () {
    const currentRoute = this.$route.path
    const foundedPart = currentRoute.split('/')[2]

    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].path === foundedPart) {
        this.item = i
      }
    }
  },
  name: 'GeneralSettings',
  data: () => ({
    item: 0,
    items: [
      { text: 'Plans & Pricing', icon: 'mdi-card-text-outline', path: 'pricing-content' },
      {
        text: 'Token Settings',
        icon: 'mdi-shield-key-outline',
        path: 'token-settings'
      },
      {
        text: 'Parameter Settings',
        icon: 'mdi-tune',
        path: 'parameter-settings'
      },
      {
        text: 'Email Settings',
        icon: 'mdi-email-outline',
        path: 'email-settings'
      },
      {
        text: 'Key Settings',
        icon: 'mdi-key-outline',
        path: 'key-settings'
      },
      {
        text: 'Application Automation Service Settings',
        icon: 'mdi-robot-outline',
        path: 'app-automation-settings'
      }
    ]
  })
}
</script>

<style scoped>

</style>
